import Banner from "../assets/images/Product-Description-banner.jpg";
import MobileBanner from "../assets/images/Product-Description-banner_Mobile.jpg";
import ChewBarFlavoursImage from "../assets/images/Product 2.png";

import React from "react";

function ChewBarFlavoursPage() {
  const nutritionData = [
    { label: "100% natural dog chew & occupier" },
    { label: "Preservative-free and gluten-free" },
    { label: "Suitable for all dogs 3 months+" },
    { label: "Low fat" },
    { label: "Low lactose" },
    { label: "Rich in protein" },
    { label: "Extra long-lasting" },
    { label: "Helps fight plaque and tartar" },
    { label: "Safe and Digestible" },
    { label: "Irresistible Flavor" },
  ];

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#EBEBEB" }}>
      <div className="container py-5">
        {/* Header */}
        <div className="text-center mb-5 position-relative">
          <h2
            className="fw-normal mb-0"
            style={{
              color: "#666",
              fontSize: "1.8rem",
              zIndex: 2,
              position: "relative",
            }}
          >
            Chew Bar
          </h2>
          <div
            style={{
              position: "absolute",
              top: "-30px",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "clamp(5rem, 15vw, 10rem)",
              fontFamily: "'Brush Script MT', cursive",
              color: "rgba(255, 255, 255, 0.5)",
              fontWeight: "bold",
              zIndex: 1,
              whiteSpace: "nowrap",
              lineHeight: "1",
            }}
          >
            Flavours
          </div>
        </div>

        {/* Content Row */}
        <div className="row g-5 align-items-center mt-5">
          {/* Product Image */}
          <div className="col-lg-5">
            <div
              className="bg-white p-5 d-flex align-items-center justify-content-center"
              style={{
                borderRadius: "30px",
                minHeight: "400px",
              }}
            >
              <div className="text-center" style={{ fontSize: "150px" }}>
                <img
                  src={ChewBarFlavoursImage}
                  alt="Protein Powder"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "20px",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="col-lg-7">
            {/* Description */}
            <p
              className="text-muted mb-5"
              style={{
                fontSize: "1rem",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Introducing our delicious and nutritious Flavored
              Dog Chew Bars – the perfect treat for your four-legged best
              friend! Crafted with love and care, this unique dog chew offers a
              combination of taste and health benefits that your pet will adore.
              This is available in sizes and flavors like strawberry, coconut,
              pumpkin, blueberry, mulberry, mint, turmeric, and many more.
            </p>

            {/* Nutrition Information */}
            <div>
              <h3
                className="fw-bold mb-4"
                style={{
                  color: "#555",
                  fontSize: "1.8rem",
                }}
              >
                Product Details
              </h3>

              <div className="row g-3">
                {nutritionData.map((item, index) => (
                  <div key={index} className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted" style={{ fontSize: "1rem" }}>
                        <li>{item.label}</li>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
        
        body {
          font-family: 'Poppins', sans-serif;
        }
        
        h2, h3 {
          font-family: 'Poppins', sans-serif;
        }
      `}</style>
    </div>
  );
}

const ChewBarFlavours = () => {
  return (
    <>
      <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
        {/* Banner Section - Starts from absolute top */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "800px",
            overflow: "hidden",
          }}
        >
          <img
            src={Banner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block",
            }}
            className="desktop-banner"
          />
          <img
            src={MobileBanner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "none",
            }}
            className="mobile-banner"
          />
          <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
        </div>
      </div>
      <ChewBarFlavoursPage />
    </>
  );
};

export default ChewBarFlavours;
